export const text_html = `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Welcome Page</title>
    <link rel="stylesheet" href="styles.css">
</head>
<body>
    <div class="container">
        <header>
            <h1>Welcome to Our Website!</h1>
        </header>
        <main>
            <p>We're excited to have you here. Explore our content and enjoy your stay!</p>
        </main>
        <footer>
            <p>&copy; 2024 Your Website. All rights reserved.</p>
            <p class="patent-note">Tejmul Movin</p>
        </footer>
    </div>
</body>
</html>
`;


export const text_css = `/* Reset some default styles */
body, h1, p {
    margin: 0;
    padding: 0;
    font-family: Arial, sans-serif;
}

body {
    background-color: #f0f8ff;
    color: #333;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    text-align: center;
}

.container {
    max-width: 600px;
    margin: 0 auto;
    padding: 20px;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

header {
    margin-bottom: 20px;
}

header h1 {
    font-size: 2.5rem;
    color: #4a90e2;
}

main p {
    font-size: 1.2rem;
    margin-bottom: 20px;
}

footer {
    margin-top: 20px;
    font-size: 0.9rem;
    color: #777;
}
` ;


export const text_js = ``;